import { ImageInputModel } from "@husky-hrc/Framework/Types/ApiModel";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage from "@insite/mobius/LazyImage";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface TactonImageStyles {
    tactonImageStyles?: InjectableCss;
}

export const tactonImageStyles: TactonImageStyles = {
    tactonImageStyles: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            display: flex;
                            justify-content: center;
                        `,
                    ],
                    "max",
                )}
        `,
    },
};
interface OwnProps {
    input: ImageInputModel;
}

type Props = OwnProps;

const styles = tactonImageStyles;

const TactonImage = ({ input }: Props) => {
    return (
        <StyledWrapper {...styles.tactonImageStyles}>
            <LazyImage src={input.src} altText={input.alt} />
        </StyledWrapper>
    );
};

export default TactonImage;
